import type { UserInvitation } from "@/types/userInvitation";

/**
 * Resolves which location access group scopes the welcome /location editing UI.
 * When an invitation is present, only the invitation document applies (missing field = full org for that link).
 * Otherwise use the signed-in profile, then custom claims (e.g. anonymous token users).
 */
export function getEffectiveLocationAccessGroupIdForWelcome(
  invitation: UserInvitation | null,
  userProfile: { locationAccessGroupId?: string } | null | undefined,
  claimsGroupId: string | null
): string | null {
  if (invitation) {
    return invitation.locationAccessGroupId ?? null;
  }
  return userProfile?.locationAccessGroupId ?? claimsGroupId ?? null;
}
